module.exports = __webpack_public_path__ + "img/75580.050b1cdc.svg";